import { render, staticRenderFns } from "./Updates.vue?vue&type=template&id=4717a40c&scoped=true"
import script from "./Updates.vue?vue&type=script&lang=js"
export * from "./Updates.vue?vue&type=script&lang=js"
import style0 from "./Updates.vue?vue&type=style&index=0&id=4717a40c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4717a40c",
  null
  
)

export default component.exports